import React from "react";
import {
    Box,
    Button, Card, CardContent,
    Typography
} from "@material-ui/core";
import { Link as RouterLink } from 'react-router-dom';
import HowToRegIcon from "@material-ui/icons/HowToReg";



import AppStore from "../AppStore";
import withStyles from "@material-ui/core/styles/withStyles";
import Container from "@material-ui/core/Container";

import moment from 'moment';
import {Skeleton} from "@material-ui/lab";
import {FormattedMessage} from "react-intl";


const styles = () => ({
    routerLink: {
        textDecoration: 'none'
    }
});

class ReservationData extends React.Component
{
    static contextType = AppStore;

    bookingData = null;

    _isMounted = false;

    componentWillUnmount() {
        this._isMounted = false
    }

    componentDidMount() {
        this._isMounted = true
        const appStore = this.context;

        appStore.getBookingData(bookingData => {
            // Si no chequeamos esto tira un error cuando se pasa de pagina antes que termine de cargar
            if (this._isMounted) {
                this.bookingData = bookingData;
                this.setState({});
            }
        })
    }

    render() {
        const { classes } = this.props;
        const appStore = this.context;
        const bookingData = this.bookingData;

        return (
            <>
                <Card>
                    <CardContent>
                        <Typography color={"textSecondary"} variant={"overline"}>
                            <FormattedMessage id="app.home.holder" />
                        </Typography>
                        <Typography variant={"body1"} gutterBottom>
                            {appStore.getUserName()}
                        </Typography>

                        {bookingData && bookingData['status'] >= 20 &&
                            <>
                                <Typography color={"textSecondary"} variant={"overline"}>
                                    <FormattedMessage id="app.home.room"/>
                                </Typography>
                                <Typography variant={"body1"} gutterBottom>
                                    {bookingData
                                        ? (bookingData['roomName'] || "-")
                                        : <Skeleton width={280}/>
                                    }
                                </Typography>
                            </>
                        }

                        <Typography color={"textSecondary"} variant={"overline"}>
                            <FormattedMessage id="app.home.arrival"/>
                        </Typography>
                        <Typography variant={"body1"} gutterBottom>
                            {bookingData
                                ? moment(bookingData['arrivalDate']).format(appStore.formatMessage('app.format.date-medium'))
                                : <Skeleton width={280}/>
                            }
                        </Typography>

                        <Typography color={"textSecondary"} variant={"overline"}>
                            <FormattedMessage id="app.home.departure"/>
                        </Typography>
                        <Typography variant={"body1"} gutterBottom>
                            {bookingData
                                ? moment(bookingData['departureDate']).format(appStore.formatMessage('app.format.date-medium'))
                                : <Skeleton width={280}/>
                            }
                        </Typography>

                        <Box
                            display={"flex"}
                            justifyContent={"center"}
                            mt={4}
                        >
                            {bookingData && bookingData['status'] === 12 &&
                                <RouterLink
                                    className={classes.routerLink}
                                    to={`/${this.context.tenant}/${this.context.resort}/checkin`}
                                >
                                    <Button
                                        variant="contained"
                                        disableElevation
                                        color="primary"
                                        startIcon={<HowToRegIcon />}
                                    >
                                        <FormattedMessage id="app.home.start-web-checkin"/>
                                    </Button>
                                </RouterLink>
                            }
                            {bookingData && bookingData['status'] > 12 && bookingData['status'] < 20 &&
                                <Typography gutterBottom variant="button" color="primary">
                                    <FormattedMessage id="app.home.thanks-for-complete"/>
                                </Typography>
                            }
                            {!bookingData && <Skeleton width={280}/>}
                        </Box>

                    </CardContent>
                </Card>
            </>
        )
    }
}


class HomePage extends React.Component
{
    render() {
        const { classes } = this.props;

        return (
            <Container maxWidth="md" style={{margin: 0, padding: 0}}>
                <ReservationData classes={classes}/>
            </Container>
        )
    }
}
export default withStyles(styles)(HomePage);
